import React, { useCallback, useContext, useMemo, useState } from 'react'
/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd'
import { BoxClass, NodeById } from '../../../helper/classes'
import { Button, Card, Icon, Popover, UL } from '@blueprintjs/core'
import { OverlayProps } from '../../../helper/configs'
import { GlobalContext, globalOnDemandVars } from '../../../helper/context'
import { reorderForBnD, truncateDefault, undoManager } from '../../../helper/functions'
import { produce } from 'immer'
import bookmark1 from '../../../../assets/images/bookmark1.gif'
import bookmark2 from '../../../../assets/images/bookmark2.gif'
import InPopover from '../../commonInterface/inPopover'
import { useTranslation } from 'react-i18next'

function BookmarksAddon ({ onNewPage, setPath }) {
  const contextValue = useContext(GlobalContext)
  const { t } = useTranslation()

  const rawbookmarkIds = useMemo(() => (contextValue.bookmarkIds), [contextValue.bookmarkIds])
  const setRawBookmarkIds = useMemo(() => (globalOnDemandVars.set_bookmarkIds), [])
  const bookmarkNodes = useMemo(() => (rawbookmarkIds.map((nodeId) => (new NodeById(nodeId)))), [rawbookmarkIds])

  // useEffect(() => {
  //   console.tron.display({
  //     name: 'BookmarksAddon',
  //     preview: isPixelMode,
  //     value: {
  //       isPixelMode,
  //       currentList: lastClosedList,
  //       lastClosedListForPixelMode: contextValue.lastClosedListForPixelMode,
  //       lastClosedList: contextValue.lastClosedList
  //     }
  //     // , important: true
  //   })
  // }, [contextValue.lastClosedList, contextValue.lastClosedListForPixelMode, isPixelMode, lastClosedList])

  const [isDragging, setIsDragging] = useState(false)
  const onDragStart = useCallback(
    () => { setIsDragging(true) },
    []
  )
  const onDragEnd = useCallback((result) => {
    setIsDragging(false)
    if (!result.destination) {
      return
    }

    const nextItems = reorderForBnD(
      rawbookmarkIds,
      result.source.index,
      result.destination.index
    )
    setRawBookmarkIds(nextItems)
  }, [rawbookmarkIds, setRawBookmarkIds])

  const inDroppable = useMemo(() => (bookmarkNodes.map((node, i) => {
    const titleFound = node.getTitle()
    return (<Draggable key={node.id} draggableId={node.id} index={i}>{
      (provided, snapshot) => (
        <div ref={provided.innerRef} {...provided.draggableProps} key={node.id}
          css={css`display: flex;
        & .visibleIfHover {
          visibility: hidden;
        }
        & .grabCursor {
          cursor: grab;
        }
        & .grabCursor:active {
          cursor: grabbing;      
        }
        &:hover .visibleIfHover {
          visibility: visible;
        }
`}
        >
          <div className={'bp3-button bp3-minimal visibleIfHover grabCursor'} {...provided.dragHandleProps}>
            <Icon icon={'drag-handle-vertical'} iconSize={20} color={'var(--gray10)'} />
          </div>
          <Button title={titleFound || ''} icon={'bookmark'} fill disabled={titleFound === false} minimal css={css`justify-content: start; ${onNewPage ? 'max-width: 130px;' : ''}`} onClick={() => {
            if (onNewPage) {
              setPath({ node })
            } else {
              node.onClick()
            }
          }}>{titleFound === false ? t('Deleted') : (titleFound ? truncateDefault(titleFound, true, onNewPage) : <span css={css`color: var(--gray6);`}>Blank</span>)}</Button>
          <Button className={'visibleIfHover'} icon={<Icon icon={'cross'} iconSize={20} color={'var(--gray10)'} />} minimal onClick={() => {
            globalOnDemandVars.set_bookmarkIds(produce(globalOnDemandVars.bookmarkIds(), draft => {
              const index = draft.findIndex((nodeId) => (nodeId === node.id))
              draft.splice(index, 1)
            }))
          }} />
        </div>)}</Draggable>
    )
  })), [bookmarkNodes, onNewPage, setPath, t])

  const result = useMemo(() => ((
    <div css={css`font-size: 1.5em !important; font-weight: bold !important;`}>
      { bookmarkNodes.length ? null : (
        <div css={css`text-align: center;`}>
          <br /><br />
          <Icon icon={'bookmark'} iconSize={32} color={'var(--gray10)'} />
          <br /><br />
          {t('Nothing Here')}
          <br /><br />
          <Popover {...OverlayProps} position={'left'} content={<InPopover>
            <Card className='mini' elevation={2}>
              <img src={bookmark1} />
              <br />
              {t('Right click on the circle of the node')}
            </Card>
            <br />
            <Card className='mini' elevation={2}>
              <img src={bookmark2} />
            </Card>
          </InPopover>}>
            <Button icon={<Icon icon={'help'} iconSize={16} color={'var(--gray10)'} />} text={t('How to Add')} minimal css={css`color: var(--gray10) !important;`} /></Popover>
        </div>
      ) }
      <DragDropContext
        // TODO 항목 아무것도 없으면 null 시키기
        // onBeforeDragStart={onBeforeDragStart}
        onDragStart={onDragStart}
        // onDragUpdate={onDragUpdate}
        onDragEnd={onDragEnd}
      >
        <Droppable droppableId='bookmarks'>
          {(provided, snapshot) => (
            <div
              ref={provided.innerRef}
              style={{
                backgroundColor: (isDragging && !snapshot.isDraggingOver) ? '#FFB366' : 'transparent'
              }}
              css={css`
${onNewPage ? `
display: flex; flex-wrap: wrap; max-height: 160px;
& > * {
  flex-grow: 1;
  flex-basis: 150px;
}
` : ''}
              `}
              {...provided.droppableProps}
            >
              {/* <div css={css`height: 1.5em;`} /> */}
              {inDroppable}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </div>
  )
  ), [bookmarkNodes.length, inDroppable, isDragging, onDragEnd, onDragStart, onNewPage, t])
  return result
}

// function BookmarksAddon (props) {
//   return (
//     <GlobalContext.Consumer>
//       {({ lastClosedList }) => (<InnerLastClosedAddOn
//         {...props} contextValue={{ lastClosedList }}
//       />)}
//     </GlobalContext.Consumer>
//   )
// }

const BookmarksAddOnBoxClass = new BoxClass(BookmarksAddon, 'Bookmarks', null, 1, { order: 1, onlyForTheseLocations: ['/organizing'] })

export default BookmarksAddOnBoxClass
export { BookmarksAddon }
